import React from 'react';
import { Result } from '../../utils';

import styles from './ResultSection.module.scss';

const ResultSection: React.FC<any> = ({ title, results }: { title?: string; results: Result[] }) => {
  return (
    <section>
      {title && <h2>{title}</h2>}
      <ul className={styles.details}>
        {results.map((result) => (
          <li key={result.label}>
            <ul>
              <li>{result.label}</li>
              <li className={result.highligthed ? styles.highligthed : undefined}>{result.value}</li>
            </ul>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ResultSection;
